export default {
  name: 'DialogAlert',
  props: {
    scrollable: {
      type: Boolean,
      default: true,
    },
    scrollContentOffset: {
      type: Boolean,
      default: false,
    },
    stickyFooter: {
      type: Boolean,
      default: false,
    },
    stickyClose: {
      type: Boolean,
      default: false,
    },
    roundCloseButton: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    roundTop: {
      type: Boolean,
      default: true,
    },
    roundBottom: {
      type: Boolean,
      default: true,
    },
    roundLeft: {
      type: Boolean,
      default: true,
    },
    roundRight: {
      type: Boolean,
      default: true,
    },
    denseGuideH: {
      type: Boolean,
      default: false,
    },
    denseGuideV: {
      type: Boolean,
      default: false,
    },
    containerStyle: {
      type: [Object, String, Array],
      required: false,
      default: '',
    },
    size: {
      type: String,
      default: 'm',
      validator: (value) => {
        return ['l', 'm', 's', 'mobile'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    sizeClass() {
      return this.size ? `${this.className}_size-${this.size}` : '';
    },
  },
  methods: {
    close: function (event) {
      this.$emit('close', event);
    },
  },
};
